import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { ModelIcon } from './ModelIcon';
import { models } from '../data/kit';
import { getAccent } from '../utils/accent';
export function ModelsOverview() {
  return <section className="w-full bg-paper py-20 lg:py-28" aria-labelledby="que-es" data-id="element-216" data-mp="3jb7afctoq9am">
      <div className="mx-auto max-w-6xl px-5" data-id="element-217" data-mp="3nbzgjx79fy2o">
        <div className="max-w-3xl" data-id="element-218" data-mp="3ndu3fh23e09e">
          <h2 id="que-es" className="font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl" data-id="element-219" data-mp="2qlql4o1d38im">
            ¿Qué es Kit Ingresos Online?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-220" data-mp="2vmo0ytywfqgy">
            Es una colección práctica diseñada para personas que quieren empezar a generar ingresos online pero
            todavía no saben qué modelo elegir ni cómo dar los primeros pasos.
          </p>
          <p className="mt-8 font-semibold text-ink" data-id="element-221" data-mp="ev4rbkjdyc72">Vas a aprender tres alternativas:</p>
        </div>

        <div className="mt-6 grid gap-px overflow-hidden rounded-3xl bg-line md:grid-cols-3" data-id="element-222" data-mp="jtfzzrxy2gnp">
          {models.map(model => {
          const a = getAccent(model.accent);
          return <a key={model.name} href={model.href} className="group flex flex-col bg-surface p-7 transition-colors duration-150 ease-out hover:bg-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ink lg:p-8" data-id="element-223" data-mp="14fdt25ztqip5">
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${a.soft} ${a.text}`} data-id="element-224" data-mp="qh60sbdqg5kb">
                  <ModelIcon accent={model.accent} className="h-6 w-6" data-id="element-225" data-mp="lmi8e1flyr0g" />
                </span>
                <h3 className={`mt-5 font-display text-2xl font-black ${a.text}`} data-id="element-226" data-mp="gmxbdwk00sqd">{model.name}</h3>
                <p className="mt-3 leading-relaxed text-muted" data-id="element-227" data-mp="boc97rl6ryza">{model.description}</p>
                <span className="mt-auto flex items-center gap-1.5 pt-6 text-sm font-semibold text-ink" data-id="element-228" data-mp="6qaufiusmltm">
                  Ver el volumen
                  <ArrowDownIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-y-0.5" aria-hidden="true" data-id="element-229" data-mp="3oa19qvf2rq13" />
                </span>
              </a>;
        })}
        </div>

        <div className="mt-12 text-center" data-id="element-230" data-mp="3fa4pd5zpxdbu">
          <p className="text-lg text-muted" data-id="element-231" data-mp="3fb5xb1lftjpc">No necesitás hacer los tres.</p>
          <p className="mt-1 font-display text-2xl font-black sm:text-3xl" data-id="element-232" data-mp="3k8po10zbnoy6">Necesitás encontrar uno que encaje con vos.</p>
        </div>
      </div>
    </section>;
}